import { ReactNode } from "react";

interface MockupWindowProps {
	children: ReactNode;
	className?: string;
}

/**
 * Browser-window frame used as a screenshot stand-in for the NIS360 platform.
 * Replace the mockup contents with real product screenshots once available.
 */
export default function MockupWindow({ children, className = "" }: MockupWindowProps) {
	return (
		<div
			className={`w-full bg-white rounded-2xl shadow-raised overflow-hidden border border-border ${className}`}
		>
			<div className="flex items-center gap-2 px-4 py-3 bg-surface border-b border-border">
				<span className="w-3 h-3 rounded-full bg-danger" />
				<span className="w-3 h-3 rounded-full bg-warning" />
				<span className="w-3 h-3 rounded-full bg-success" />
				<div className="ml-3 flex-1 max-w-[260px] h-6 bg-white border border-border rounded-md flex items-center px-3">
					<span className="text-[11px] text-subtle font-urbanist truncate">app.nis360.de</span>
				</div>
			</div>
			<div className="p-4 sm:p-5">{children}</div>
		</div>
	);
}
